/**
 * Time picker component types
 */

/**
 * Time format options
 */
export enum TimeFormat {
  /** 12-hour format with AM/PM (e.g., 02:30 PM) */
  Hour12 = '12h',
  /** 24-hour format (e.g., 14:30) */
  Hour24 = '24h',
}

/**
 * Parsed time object
 */
export interface ParsedTime {
  readonly hours: number;
  readonly minutes: number;
  readonly period?: 'AM' | 'PM'; // Only for 12h format
}
